import React from 'react';
import { Switch } from '../../ui/switch';
import { Label } from '../../ui/label';
import { Checkbox } from '../../ui/checkbox';
import './SettingsPage.css'; // We'll need some basic styling

const SettingsPage = () => {
  // Placeholder state/logic for toggles and checkboxes
  const [isWallpaperEnabled, setIsWallpaperEnabled] = React.useState(() => {
    return localStorage.getItem('wallpaperEnabled') === 'true';
  });
  const [viewSettings, setViewSettings] = React.useState({
    ideas: true,
    decisions: true,
    todo: true,
    tasksProjects: true,
    journal: true,
    notebooks: true,
    webLinks: true,
  });

  const handleViewChange = (id: keyof typeof viewSettings) => {
    setViewSettings(prev => ({ ...prev, [id]: !prev[id] }));
    // TODO: Add logic to actually hide/show items in the sidebar based on this state
  };

  const handleWallpaperToggle = (checked: boolean) => {
    setIsWallpaperEnabled(checked);
    localStorage.setItem('wallpaperEnabled', String(checked));
    document.body.classList.toggle('wallpaper-enabled', checked);
  };

  const sidebarItems = [
    { id: 'ideas', label: 'Ideas' },
    { id: 'decisions', label: 'Decisions' },
    { id: 'todo', label: 'ToDo' },
    { id: 'tasksProjects', label: 'Tasks/Projects' }, // Assuming this corresponds to a single item or group
    { id: 'journal', label: 'Journal' },
    { id: 'notebooks', label: 'Notebooks' },
    { id: 'webLinks', label: 'WebLinks' }, // Corrected capitalization if needed
  ];

  return (
    <div className="settings-page">
      <section className="settings-section">
        <h2>Theme</h2>
        <div className="settings-item">
          <Label htmlFor="wallpaper-toggle" className="flex items-center gap-3 cursor-pointer">
            <Switch
              id="wallpaper-toggle"
              checked={isWallpaperEnabled}
              onCheckedChange={handleWallpaperToggle}
            />
            <span>Enable Tiled Background Wallpaper</span>
          </Label>
          <p className="settings-description">
            Overlays a subtle tiled background image on the main content area. (Requires page refresh to see changes currently)
          </p>
          {/* TODO: Implement actual background toggle logic in Layout.tsx */}
        </div>
      </section>

      <section className="settings-section">
        <h2>View</h2>
        <p className="settings-description">Control which sections appear in the sidebar menu.</p>
        <div className="settings-view-grid">
          {sidebarItems.map(item => (
            <div key={item.id} className="settings-item">
              <Label htmlFor={`view-${item.id}`} className="flex items-center gap-2 cursor-pointer">
                <Checkbox
                  id={`view-${item.id}`}
                  checked={viewSettings[item.id as keyof typeof viewSettings]}
                  onCheckedChange={() => handleViewChange(item.id as keyof typeof viewSettings)}
                />
                {item.label}
              </Label>
            </div>
          ))}
        </div>
      </section>

      <section className="settings-section">
        <h2>Email Account</h2>
        <p className="settings-description">(Coming Soon) Connect your email account.</p>
      </section>

      <section className="settings-section">
        <h2>Slack Account</h2>
        <p className="settings-description">(Coming Soon) Connect your Slack account.</p>
      </section>
    </div>
  );
};

export default SettingsPage; 